import { FC } from 'react';
import { cn } from '@new/lib';
import { ChatSidebar } from '../components/ChatSidebar/ChatSidebar';
import { ChatConversation } from '../components/ChatConversation/ChatConversation';
import { ChatEmptyState } from '../components/ChatEmptyState/ChatEmptyState';
import { useChatPage } from '../hooks/useChatPage';

export const ChatPage: FC = () => {
  const {
    chats,
    currentUserId,
    selectedChat,
    selectedChatId,
    unreadChatIds,
    mobileShowConversation,
    handleSelectChat,
    handleBack,
    handleSendMessage,
  } = useChatPage();

  return (
    <div className="flex w-full bg-(--bg-blue) h-[calc(100vh-85px)] overflow-hidden gap-5 px-5">
      <div
        className={cn(
          'shrink-0 h-full w-full md:w-[497px]',
          mobileShowConversation ? 'hidden md:block' : 'block'
        )}
      >
        <ChatSidebar
          chats={chats}
          currentUserId={currentUserId}
          selectedChatId={selectedChatId}
          unreadChatIds={unreadChatIds}
          onSelectChat={handleSelectChat}
        />
      </div>

      <div className={cn('flex-1 min-w-0', mobileShowConversation ? 'block' : 'hidden md:block')}>
        {selectedChat ? (
          <ChatConversation
            chat={selectedChat}
            currentUserId={currentUserId}
            onSendMessage={handleSendMessage}
            onBack={handleBack}
          />
        ) : (
          <ChatEmptyState />
        )}
      </div>
    </div>
  );
};
